require("!!/home/ubuntu/taxpadweb/node_modules/script-loader/addScript.js")(require("!!/home/ubuntu/taxpadweb/node_modules/raw-loader/index.js!/home/ubuntu/taxpadweb/node_modules/chart.js/dist/Chart.min.js"))


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/script-loader!/home/ubuntu/taxpadweb/~/chart.js/dist/Chart.min.js
// module id = ../../../../script-loader/index.js!../../../../chart.js/dist/Chart.min.js
// module chunks = 4